import { UseRecordsOptions } from "../../api/useRecords";
import { customizedTreatmentProvidedAppointmentFields } from "../../components/filters/routedCustomizedFields";
import { RecordContextType } from "../../components/record/Record";
import { clientsSearchSettings } from "../../utils/createSearchFilter";
import { queryClient } from "../../main";
import { DoStuffAfterReturnType } from "../../types/groups.types";

export const treatmentsOptions = {
    fieldsToRemove: {
        fieldNamesToRemove: ["id", "user_created", "treatment_status", "treatment_provided"],
        fieldTypesToRemove: [""],
    },
    groupsOptions: {
        mutationOptions: { skipOptimisticUpdate: true },
        fieldsWithExtraOptions: [
            {
                field: "client_manager",
                relatedTable: "technicians",
                displayTemplate: "{{user_id.first_name}} {{user_id.last_name}}",
            },
            {
                field: "theurapists_involved_in_treamtent",
                relatedTable: "technicians",
                displayTemplate: "{{user_id.first_name}} {{user_id.last_name}}",
                enabled: true,
                sort: "user_id.first_name",
            },
            {
                field: "relative_resposible_for_treatment",
                relatedTable: "relatives",
                relatedWith: "client",
                displayTemplate: "{{Nome}}",
                createFilter: (params: any) => filterRelatives(params),
                enabled: true,
                limit: 100
            },
            {
                field: "client_owner",
                sort: "user_id.first_name",
                enabled: true,
            },
            {
                field: "client",
                createFilter: (inputValue: string) => clientsSearchSettings(inputValue),
            },
            {
                field: "contracts",
                fileFolder: "dea81570-81a4-4723-bb95-35f36b973bba",
            },
            {
                field: "other_treatment_documents",
                fileFolder: "a8a68c39-f6ed-4572-a9be-4b03478079da",
            },
            {
                field: "internal_documents",
                fileFolder: "a8a68c39-f6ed-4572-a9be-4b03478079da",
            },
            {
                field: "partners",
                relatedTable: "professional_partners",
                displayTemplate: "{{specialization}} - {{name}} - {{phone}}",
                enabled: true,
            },
            {
                field: "treatment_conclusion",
                charactersLimit: 5000
            },
            {
              field: "treatment_provided",
              isCustomRoute: true,
            },
            {
                field: "diagnose_main",
                enabled: true,
            },
            {
                field: "diagnose_secondary_multi",
                relatedTable: "disorders",
                displayTemplate: "{{name}}",
                enabled: true,
            },
{
                field: "next_step_group",
                hidden: true,
            },
            {
                field: "treatment_status_new",
                defaultValue: "waiting_report",
            },
        ],
        doStuffAfterUpdate: async (data: any, updatedData: any, dirtyFields?: Array<string>) => {
            return refreshClientOwnerAfterStatusChange(data.id, updatedData, dirtyFields);
        },
    },
    fieldsToAddFilter: customizedTreatmentProvidedAppointmentFields,

    createRelatedParams: (params: RecordContextType | undefined) => createTreatmentParams(params),
} as UseRecordsOptions;

const createTreatmentParams = async (recordContext: RecordContextType | undefined) => {
    if (!recordContext?.item) return;
    if (recordContext.entity === "clients") return `[clients][id]=${recordContext.item.id}`;

};

const filterRelatives = (params: any) => {
    let filter = {};

    const clientId = params?.id;
    if (clientId) {
        filter = {
            _and: [
                {
                    client_id: {
                        id: {
                            _eq: clientId,
                        },
                    },
                },
            ],
        };
    }

    return filter;
};

const refreshClientOwnerAfterStatusChange = (treatmentId: string, updatedData: any, dirtyFields?: Array<string>): DoStuffAfterReturnType | undefined => {
    const onlyStatusChanged = dirtyFields?.length === 1 && dirtyFields[0] === "treatment_status_new";
    const isTargetStatus = updatedData?.treatment_status_new === "waiting_start_of_treatment";
    if (!onlyStatusChanged || !isTargetStatus) return;

    setTimeout(() => {
        queryClient.invalidateQueries({
            predicate: (query: any) => query.queryKey[0].includes(`treatments-${treatmentId}`),
        });
    }, 500);

    return { success: true, message: "", severity: "success" as const };
};
